import useReceiptDetails from 'src/hooks/useReceiptDetails';

const PoNumber = () => {
  const { receiptData } = useReceiptDetails();
  return (
    <div
      className="p-1 flex flex-col gap-1 text-[13px]"
      title={receiptData?.poNum?.toString() ?? ''}
    >
      <p className="font-bold">PO # </p>
      <p className="pl-1">{receiptData?.poNum}</p>
    </div>
  );
};

export default PoNumber;
